// Diamond
export default [
    {type: "freeplay", to: "$8"},
    {type: "weekly_rakeback", to: "15%"},
    {type: "monthly_rakeback", to: "12%"},
    {type: "birthday_bonus", to: "$25 + 20%"},
    {type: "deposit_assist_token", to: "$2"}
]